import React, { useState } from "react";
import { useAuth } from "../auth/useAuth.js";
import { login as loginApi } from "../api/authService.js";
import { useNavigate } from "react-router-dom";
import { Form, Button, Card, Container, Row, Col } from "react-bootstrap";
import { Eye, EyeSlash } from "react-bootstrap-icons";
import { toast } from "react-toastify";

const LoginForm = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("username:", username);
    console.log("password:", password);
    try {
      const userData = await loginApi({ username, password });
      localStorage.setItem("user", JSON.stringify(userData));
      login(userData);
      navigate("/dashboard");
    } catch (error) {
      toast.error(error.message);
      // alert(error.message);
    }
  };

  return (
    // <form onSubmit={handleSubmit}>
    //   <h2>Login</h2>
    //   <input type="text" value={username} onChange={(e) => setUsername(e.target.value)} required /><br/>
    //   <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required /><br/>
    //   <button type="submit">Login</button>
    // </form>

    <div className="loginTrBg">
      <div className="loginTrBgIn">
        <Card className="border-0 rounded">
          <Card.Body>
            <div className="loginTitleWrap">
              <h5 className="text-center">Login to your Account</h5>
            </div>

            <Form onSubmit={handleSubmit}>
              <Form.Group className="form-group" controlId="formUsername">
                <Form.Label>Username</Form.Label>

                <Form.Control
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="Enter username"
                  required
                />
              </Form.Group>

              <Form.Group className="form-group" controlId="formPassword">
                <Form.Label>Password</Form.Label>
                <div style={{ position: "relative" }}>
                  <Form.Control
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Enter password"
                    required
                    style={{ paddingRight: "40px" }}
                  />
                  <span
                    onClick={() => setShowPassword(!showPassword)}
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "#6c757d",
                    }}
                  >
                    {showPassword ? <EyeSlash /> : <Eye />}
                  </span>
                </div>
              </Form.Group>

              <div className="mt-4 pt-1">
                <Button variant="dark" type="submit" className="w-100">
                  Login
                </Button>
              </div>
            </Form>
          </Card.Body>
        </Card>
      </div>
    </div>
  );
};

export default LoginForm;
